export const newDrinksData = {
  drink_1: {
    title: 'HeizenBerg Tea',
    description:
      'Refreshing Break Bad Drink. Decorated with blue jelly cut into flat shards resembling broken blue glass, sprinkled with appetizing coconut flakes. Features a banknote-shaped tapioca tube with dark pearls, while the drink itself is semi-translucent blue, transitioning into semi-translucent turquoise with tapioca pearls. Contains no blue meth.',
  },
  drink_2: {
    title: 'Nuclear Power',
    description:
      'Inside, a coffee layer on top forms a gradient through yellow-tinted Sprite, transitioning into yellow-orange juice with tapioca pearls. Decorated with a piece of Belgian waffle drizzled with green topping atop a scoop of kiwi ice cream. Features a grunge-style tube (worn paint and rusty texture). Drink composition tested with a dosimeter: radiation levels within safe limits.',
  },
  drink_3: {
    title: 'Cactus Bloom',
    description:
      'Thick smoothie with spirulina, matcha green tea, kiwi, and cactus pulp. L-theanine additive. Features a smooth yogurt ice cream ball with chia pieces and a fluffy airy cloud of lychee-flavored cotton candy. Lower layer: Lightly carbonated lime Sprite tinted with chlorella extract, creating a watercolor depth effect. Tapioca pearls colored with natural neon from blue tea flower (glows in the dark).',
  },
};
